export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11070.20d7672a.jpg";